import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import getAuth0Config from "./utils/auth0.js";

/**
 * Wraps Auth0Provider with a react-router-aware onRedirectCallback so that
 * after any Auth0 (including the Intuit OpenID connection) redirect completes,
 * the SPA lands on the right in-app route instead of a hard page reload.
 *
 * appState.disconnectRealmId is used by the Intuit "Disconnect URL" flow
 * (see pages/IntuitDisconnect) to carry the realmId through to
 * pages/IntuitDisconnectComplete, which syncs our local DB state.
 *
 * appState.returnTo of "/intuit-connect" is used by the Intuit Connect /
 * Reconnect URL flow so OAuth starts after OpenID SSO completes.
 */
const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();
  const auth0Config = getAuth0Config();

  const onRedirectCallback = (appState) => {
    if (appState?.disconnectFlow || appState?.disconnectRealmId) {
      const q = appState.disconnectRealmId
        ? `?realmId=${encodeURIComponent(appState.disconnectRealmId)}`
        : "";
      navigate(`/intuit-disconnect-complete${q}`, { replace: true });
      return;
    }
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirect_url,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;
